import { api } from "./api";
import type { Drzava } from "./radnici";

export async function fetchCountries(signal?: AbortSignal): Promise<Drzava[]> {
  return (await api.get<Drzava[]>("/radnici/drzave", { signal })).data;
}
